import React, { useId } from 'react';

// 案A：深藍の地に金の七宝柄（金色は控えめに透過）
const ShippouGoldEffect = () => {
  // インスタンスごとに一意なパターンID（サムネイルと本体の重複回避）
  const patternId = 'shippouGold-' + useId().replace(/:/g, '');

  const styles = {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      background: 'radial-gradient(120% 140% at 50% -10%, #26407e 0%, #16264f 55%, #0e1a38 100%)',
    },
    pattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0.15, // 金色をさらに薄く透過
    },
    glow: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'radial-gradient(60% 70% at 50% 45%, rgba(200,162,74,0.12), transparent 70%)',
    },
  };

  return (
    <div style={styles.container}>
      <svg style={styles.pattern} width="100%" height="100%" aria-hidden="true">
        <defs>
          <pattern id={patternId} width="64" height="64" patternUnits="userSpaceOnUse">
            <g fill="none" stroke="#c8a24a" strokeWidth="1.2">
              <circle cx="0" cy="0" r="32" />
              <circle cx="64" cy="0" r="32" />
              <circle cx="0" cy="64" r="32" />
              <circle cx="64" cy="64" r="32" />
              <circle cx="32" cy="32" r="32" />
            </g>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${patternId})`} />
      </svg>
      <div style={styles.glow} />
    </div>
  );
};

export default ShippouGoldEffect;
